<template>
  <div class="header">
    <!-- Botón hamburguesa (solo móvil) -->
    <button class="header-hamburger" @click="toggleSidebar" aria-label="Menú">
      <span></span>
      <span></span>
      <span></span>
    </button>

    <!-- Zona izquierda: logo alineado con la sidebar (solo escritorio) -->
    <div class="header-left">
      <div class="header-left-logo">
        <img :src="logoUrl || require('@/assets/logo.png')" alt="Logo" />
      </div>
    </div>

    <!-- Título -->
    <div class="header-title">
      <p>{{ $t("main.name") }}</p>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "TopBar",
  mounted() {
    this.updateTime();
    setInterval(this.updateTime, 1000);
  },
  data() {
    return {
      date: new Date(),
    };
  },
  computed: {
    ...mapState("config", ["logoUrl"]),
  },
  methods: {
    updateTime: function () {
      this.date = new Date();
    },
    toggleSidebar: function () {
      this.$root.$emit("toggle-sidebar");
    },
  },
};
</script>

<style>
.header {
  font-family: "Roboto", sans-serif;
  display: flex;
  flex-flow: row;
  align-items: center;
  background-color: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.07);
  height: 58px;
  flex-shrink: 0;
  width: 100%;
  box-sizing: border-box;
}

/* ── HAMBURGUESA (solo móvil) ──────────────────────────────────── */
.header-hamburger {
  display: none; /* oculto en escritorio */
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
  width: 44px;
  height: 44px;
  background: transparent;
  border: none;
  cursor: pointer;
  flex-shrink: 0;
  padding: 0 12px;
  margin-left: 4px;
}

.header-hamburger span {
  display: block;
  width: 20px;
  height: 2px;
  background-color: #1e293b;
  border-radius: 2px;
  transition: background 0.15s;
}

.header-hamburger:hover span {
  background-color: #0284c7;
}

/* ── ZONA IZQUIERDA: logo ──────────────────────────────────────── */
.header-left {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 196px;
  flex-shrink: 0;
  background-color: #f1f5f9;
  border-right: 1px solid #e2e8f0;
  height: 100%;
  padding: 0 12px;
  box-sizing: border-box;
}

.header-left-logo img {
  display: block;
  max-height: 38px;
  width: auto;
}

/* ── TÍTULO ────────────────────────────────────────────────────── */
.header-title {
  flex: 1;
  padding-left: 22px;
  min-width: 0;
}

.header-title p {
  margin: 0;
  font-size: 1.15em;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.01em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.material-icons {
  font-size: 11px;
  color: #000000;
}

/* ── RESPONSIVE: tablet / móvil (≤ 768px) ─────────────────────── */
@media (max-width: 768px) {
  .header {
    height: 48px;
    padding: 0;
  }

  /* Mostrar hamburguesa */
  .header-hamburger {
    display: flex;
  }

  /* Ocultar zona de logo — el hamburguesa ocupa su lugar */
  .header-left {
    display: none;
  }

  /* Título más pequeño */
  .header-title {
    padding-left: 8px;
  }

  .header-title p {
    font-size: 1em;
  }
}

/* ── RESPONSIVE: móvil pequeño (≤ 480px) ──────────────────────── */
@media (max-width: 480px) {
  .header-title p {
    font-size: 0.95em;
  }
}
</style>
